/* eslint-disable no-restricted-syntax */
/* eslint-disable one-var */
/* eslint-disable no-plusplus */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-props-no-spreading */

import React, { SetStateAction } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  CustomWidget,
  KPIWidget,
  QuickWidget,
  Widget,
  callGetter,
  callbackRequestsGetter,
  createWidget,
  newItemLayoutRules,
  queueCallsInProgressGetter,
  queueCallsWaitingGetter,
  queueMonitorLiveCallGetter,
  updateWidget,
} from './Utilities';
import { Abandoned, Answered, CallbackRequests, CallDirectionCountWidget, CallResultsWidget, CustomCounter, CustomerSatisfactionGauge, EcosystemCxCalls, EcosystemExCalls, EcosystemTransfersCx, EcosystemTransfersEx, InProgress, PrimaryTopics, RaiseHandUsers, RingCentral, TopPerformerCompletedCalls, TopPerformersSentiment, Waiting } from './QuickWidgets';
import { CustomizedWidgetGridItem, KPIWidgetGridItem, WidgetContainer, WidgetContainerBar } from './Widget';

export const widgetMap: Record<string, Widget> = {
 
  customized: {
    key: 'customized',
    label: 'Custom Widget',
    widgetType: 'customized',
    category: 'DIY',
    component: CustomizedWidgetGridItem,
    description: 'Customized widgets utilizing data from Queue & User deltas.',
    propGetter: (props: any) => ({
      deltas: props.deltas,
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      lightMode: props.lightMode,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: ["dimensionType", "metrics", "metricValues", "visualType"]
  } as CustomWidget,

  kpi: {
    key: 'kpi',
    label: 'KPI Widget',
    widgetType: 'kpi',
    category: 'DIY',
    component: KPIWidgetGridItem,
    description: 'KPI Widgets utilizing totals from Queue & User deltas.',
    propGetter: (props: any) => ({
      deltas: props.deltas,
      lightMode: props.lightMode,
      widgetContent: props.widgetContent,
      layout: props.layout,
    }),
    validationRequirements: ["dimensionType", "metrics", "metricValues"]
  } as KPIWidget,

  customCounter: {
    key: 'customCounter',
    label: 'CUSTOM_COUNTER',
    widgetType: 'quick',
    component: CustomCounter,
    category: "DIY",
    description: 'CUSTOM_COUNTER',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
      widgetId: props.widgetId
    }),
    validationRequirements: []
  } as QuickWidget,

  // quick widgets.
  // callResults: {
  //   key: 'callResults',
  //   label: 'Call Results',
  //   widgetType: 'quick',
  //   component: CallResultsWidget,
  //   category: 'queue',
  //   description: 'Display a list of call results from queues.',
  //   propGetter: (props: any) => ({
  //     historicalUsers: props.historicalUsers,
  //     accessToken: props.accessToken,
  //     styles: props.styles,
  //     layout: props.layout,
  //     queueCallStates: props.queueCallStates,
  //     deltas: props.deltas,
  //     widgetContent: props.widgetContent,
  //   }),
  //   validationRequirements: []
  // } as QuickWidget,

  // callDirectionCountWidget: {
  //   key: 'callDirectionCount',
  //   label: 'Queue Calls by Direction',
  //   widgetType: 'quick',
  //   component: CallDirectionCountWidget,
  //   category: 'queue',
  //   description: 'display queue calls by direction.',
  //   propGetter: (props: any) => ({
  //     historicalUsers: props.historicalUsers,
  //     accessToken: props.accessToken,
  //     styles: props.styles,
  //     layout: props.layout,
  //     queueCallStates: props.queueCallStates,
  //     deltas: props.deltas,
  //     widgetContent: props.widgetContent,
  //   }),
  //   validationRequirements: []
  // } as QuickWidget,

  customerSatisfactionGauge: {
    key: 'CustomerSatisfactionGauge',
    label: 'CSAT Score - Gauge',
    widgetType: 'quick',
    component: CustomerSatisfactionGauge,
    category: 'CSAT',
    description: 'Displays an overcall CSAT Score for the day.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,

  topPerformersSentiment: {
    key: 'topPerformersSentiment',
    label: 'Top Performers - CSAT',
    widgetType: 'quick',
    component: TopPerformersSentiment,
    category: 'CSAT',
    description: 'Display top 4 performers evaluated by CSAT Score.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,

  topPerformersCompletedCalls: {
    key: 'topPerformersCompletedCalls',
    label: 'Top Performers - Completed Calls',
    widgetType: 'quick',
    component: TopPerformerCompletedCalls,
    category: 'CSAT',
    description: 'Display top 4 performers evaluated by call frequency.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,

   primaryTopics: {
    key: 'primaryTopics',
    label: 'Primary Topics',
    widgetType: 'quick',
    component: PrimaryTopics,
    category: "misc",
    description: 'Display most discussed topics for today.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,

   raiseHandUsers: {
    key: 'abandoned',
    label: 'Raise Hand - Users',
    widgetType: 'quick',
    component: RaiseHandUsers,
    category: "users",
    description: 'Total number of abandoned queue calls.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,

  callbackRequests: {
    key: 'callbackRequests',
    label: 'Callback requests',
    widgetType: 'quick',
    component: WidgetContainer,
    category: "queue",
    description: 'Total of callback requests unchecked.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
      value: callbackRequestsGetter(props.queueDeltas),
      subheading: "Callback Req.",
      threshold: 10
    }),
    validationRequirements: []
  } as QuickWidget,

  ecosystemExCalls: {
    key: 'ecosystemExCalls',
    label: 'Call Count - EX',
    widgetType: 'quick',
    component: EcosystemExCalls,
    category: "ecosystem",
    description: 'Total EX calls.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,

    ecosystemCxCalls: {
    key: 'ecosystemCxCalls',
    label: 'Call Count - CX',
    widgetType: 'quick',
    component: EcosystemCxCalls,
    category: "ecosystem",
    description: 'Total CX calls.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,

  ecosystemTransfersEx: {
    key: 'ecosystemTransfersEx',
    label: 'CX Transfers to EX',
    widgetType: 'quick',
    component: EcosystemTransfersEx,
    category: "ecosystem",
    description: 'CX transfers to EX.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,

    ecosystemTransfersCx: {
    key: 'ecosystemTransfersCx',
    label: 'EX Transfers to CX',
    widgetType: 'quick',
    component: EcosystemTransfersCx,
    category: "ecosystem",
    description: 'EX transfers to CX.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,

    ringCentral: {
    key: 'ringCentral',
    label: 'RingCentral',
    widgetType: 'quick',
    component: RingCentral,
    category: "misc",
    description: 'RINGCENTRAL',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,


  //  calls: {
  //   key: 'calls',
  //   label: 'Calls',
  //   widgetType: 'quick',
  //   component: WidgetContainer,
  //   category: "misc",
  //   description: 'A widget boilerplate.',
  //   propGetter: (props: any) => ({
  //     historicalUsers: props.historicalUsers,
  //     accessToken: props.accessToken,
  //     styles: props.styles,
  //     layout: props.layout,
  //     queueCallStates: props.queueCallStates,
  //     deltas: props.deltas,
  //     widgetContent: props.widgetContent,
  //     value: callGetter(props.deltas),
  //   }),
  //   validationRequirements: []
  // } as QuickWidget,

  queueMonitorCallsWaiting: {
    key: "queueMonitorCallsWaiting",
    label: "Queue Monitor - Calls Waiting",
    widgetType: "quick",
    component: WidgetContainer,
    category: 'queue',
    description: "Monitor all waiting queue calls.",
    propGetter: (props: any) => ({
      layout: props.layout,
      styles: props.styles,
      queueCallStates: props.queueCallStates,
      queueDeltas: props.queueDeltas,
      value: queueCallsWaitingGetter(props.liveQueueMetrics),
      subHeading: "Calls Waiting in Queue"
    })
  },
  queueMonitorCallsInProgress: {
    key: "queueMonitorCallsInProgress",
    label: "Queue Monitor - Calls in Progress",
    widgetType: "quick",
    component: WidgetContainer,
    category: 'queue',
    description: "Monitor all queue calls currently in progress.",
    propGetter: (props: any) => ({
      layout: props.layout,
      styles: props.styles,
      queueCallStates: props.queueCallStates,
      queueDeltas: props.queueDeltas,
      value: queueCallsInProgressGetter(props.liveQueueMetrics),
      subHeading: "Calls In Progress"
    })
  },
  queueMonitorLiveCallsBar: {
    key: "queueMonitorLiveCallsBar",
    label: "Queue Monitor",
    widgetType: "quick",
    component: WidgetContainerBar,
    category: 'queue',
    description: "Monitor all current queue call states.",
    propGetter: (props: any) => ({
      layout: props.layout,
      styles: props.styles,
      queueCallStates: props.queueCallStates,
      queueDeltas: props.queueDeltas,
      value: queueMonitorLiveCallGetter(props.liveQueueMetrics),
    })
  },

  answered: {
    key: 'answered',
    label: 'Queue Calls - Answered',
    widgetType: 'quick',
    component: Answered,
    category: "queue",
    description: 'Total number of answered queue calls.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,
   abandoned: {
    key: 'abandoned',
    label: 'Queue Calls - Abandoned',
    widgetType: 'quick',
    component: Abandoned,
    category: "queue",
    description: 'Total number of abandoned queue calls.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,
   waiting: {
    key: 'waiting',
    label: 'Queue Calls - Waiting',
    widgetType: 'quick',
    component: Waiting,
    category: "queue",
    description: 'Total number of waiting queue calls.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,
   inProgress: {
    key: 'abandoned',
    label: 'Queue Calls - In Progress',
    widgetType: 'quick',
    component: InProgress,
    category: "queue",
    description: 'Total number of queue calls in progress.',
    propGetter: (props: any) => ({
      historicalUsers: props.historicalUsers,
      accessToken: props.accessToken,
      styles: props.styles,
      layout: props.layout,
      queueCallStates: props.queueCallStates,
      deltas: props.deltas,
      widgetContent: props.widgetContent,
    }),
    validationRequirements: []
  } as QuickWidget,
};











export const WidgetRegistry = {
  /**Create a new widget instance with a unique ID and default layout.**/
  renderWidget(key: string, props: any = {}) {
    const baseWidget = widgetMap[key];
    if (key === "example") {
      return (
         <div className={props?.styles?.gridItemContainerInner}>
            <div className={props?.styles?.gridItemBody}>
              <h1 className={props?.styles?.kpiBigText} style={{ margin: 0, textAlign: "center", fontSize: `${(props?.layout?.h) * 1.5}em`, color: props?.widgetContent?.cosmetics?.color || "inherit" }}>0</h1>
            </div>
        </div>
      )
    }
    if (!baseWidget){
      console.log('widget props: ', props);
      return (
        <>widget not found. key={key}. </>
      )
    }

    const Component = baseWidget.component;

    const filteredProps = baseWidget.propGetter ? baseWidget.propGetter(props) : props;

    return <Component {...filteredProps} />;
  },


  /**Client CRUD handlers for widgets**/
  clientCreateWidget( newItem: Widget | undefined,setNewItem: React.Dispatch<SetStateAction<Partial<Widget | undefined>>>, setWidgets: React.Dispatch<SetStateAction<Map<string, Widget>>>,setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>) {
    
    if (!newItem) return;

    // if the widget already has a widgetId, assume it's just being edited.
    const clientCurrentlyEditing = Boolean(newItem.widgetId);
    const widgetId = uuidv4();
    const newWidget: Widget = {
      ...newItem,
      widgetId,
      layout: newItem.layout ?? newItemLayoutRules(widgetId as string),
      key: newItem.key ?? newItem.widgetType,
    };

    if (clientCurrentlyEditing) {
      const newMap = new Map();
      newMap.set(newWidget.widgetId!, newWidget as Widget);
      updateWidget(newMap, setLiveDashboardErrorMsg);
    } else {
      createWidget(newWidget, setLiveDashboardErrorMsg);
    }
    setWidgets((prev) => {
        const updatedWidgets = new Map(prev);
        updatedWidgets.set(newWidget.widgetId!, newWidget)
        return updatedWidgets;
    })

    // clear widget's state
    setNewItem(undefined)
  },

  clientDeleteWidget( id: string | number, setWidgets: React.Dispatch<SetStateAction<Map<string, Widget>>>,widgets: Map<string, Widget>,setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>) {
    setWidgets((prev) => {
        const updatedWidets = new Map(prev);
        updatedWidets.delete(id as string);
        return updatedWidets;

    })
  },


  /*Search for stuff*/
  searchWidgets(searchString?: string): Widget[] {
    if (!searchString) return Object.values(widgetMap);
    const kw = searchString.toLowerCase();
    const rankedResults = Object.values(widgetMap).reduce((acc, widget) => {
      let rank = 0;
      if (widget.description?.toLowerCase().includes(kw)) rank++;
      if (widget.label?.toLowerCase().includes(kw)) rank++;
      if (widget.category?.toLowerCase()?.includes(kw)) rank++;
      if (widget.widgetId?.toLowerCase().includes(kw)) rank++;
      if (Array.isArray(widget.metatags) && widget.metatags.some((tag) => tag.toLowerCase().includes(kw))) rank++;
      if (rank > 0) {
        acc.push({ rank, widget });
      }
      return acc;
    }, [] as { rank: number; widget: Widget }[]);

    return rankedResults.sort((a, b) => b.rank - a.rank).map((entry) => entry.widget);
  },


  /**List all widget definitions*/
  getWidgets(category?: Widget['category']) {
    const allWidgets = Object.values(widgetMap);
    console.log('ALL WIDGETS: ', allWidgets)
    if (!category) return allWidgets;
    return allWidgets.filter((widget) => widget.category === category);
  },

  /**Gets all existing widget Categories. */
  getWidgetCategories() {
    const categories: string[] = [];

    for (const widget of Object.values(widgetMap)) {
      if (!categories.includes(widget?.category!)) {
        categories.push(widget?.category!);
      }
    }

    return categories;
  },
  getDescription(newWidget: Partial<Widget>) {
    const widgetkey = newWidget.key;

     let widgetFromRegistry: Widget | undefined;
    if (typeof widgetkey === "string" && Object.hasOwn(widgetMap, widgetkey)) {
      widgetFromRegistry = widgetMap[widgetkey];
    }

    if (!widgetFromRegistry) return null;

    return widgetFromRegistry.description;
  },
  
  /**Supply new widget and verifies if all required fields meet criteria, based on registry. */
  getConfirmationRequirements(newWidget: Partial<Widget>) {
    const widgetKey = newWidget.key;

    let widgetFromRegistry: Widget | undefined;
    if (typeof widgetKey === "string" && Object.hasOwn(widgetMap, widgetKey)) {
      widgetFromRegistry = widgetMap[widgetKey];
    }

    if (!widgetFromRegistry) return false;

    const { validationRequirements } = widgetFromRegistry;
    if (!validationRequirements || validationRequirements.length === 0) return true;

    const allPopulated = validationRequirements.every((field) => {
      const value = (newWidget as Record<string, unknown>)[field];
      return value !== undefined && value !== null && value !== "" && value !== "-" && value !== "--";
    });

    return allPopulated;
  },

  /**put selectable metrics/deltas here for the custom/kpi widgets 
   * utilities.tsx 703, 
   * utilities.tsx 731*/
  getDeltas(
    category?: "users" | "queues" | "air" | "ivr",
    type?: "count" | "time"
  ): Array<any> {
    const metrics: [] = [];
    return metrics; 
  }
};
